module.exports = __webpack_public_path__ + "static/media/paragraph-tag.f9b81188.JPG";